var map = {
	"./01.Ashwini.jpg": 2455,
	"./02.Bharani.jpg": 5897,
	"./03.Krittika.jpg": 7871,
	"./04.Rohini.jpg": 4529,
	"./05.Mrigshira.jpg": 2615,
	"./06.Ardra.jpg": 329,
	"./07.Punarvasu.jpg": 8599,
	"./08.Pushya.jpg": 5438,
	"./09.Ashlesha.jpg": 9043,
	"./10.Magha.jpg": 1434,
	"./11.PurvaPhalguni.jpg": 3368,
	"./12.UttaraPhalguni.jpg": 8112,
	"./13.Hasta.jpg": 2998,
	"./14.Chitra.jpg": 3825,
	"./15.Swati.jpg": 4782,
	"./16.Vishakha.jpg": 9374,
	"./17.Anuradha.jpg": 9058,
	"./18.Jyeshtha.jpg": 6978,
	"./19.Mula.jpg": 2888,
	"./20.PurvaAshada.jpg": 8613,
	"./21.UttaraAshada.jpg": 7258,
	"./22.Shravana.jpg": 7656,
	"./23.Dhanishtha.jpg": 4370,
	"./24.Shatabhisha.jpg": 2964,
	"./25.PurvaBhadrapada.jpg": 5104,
	"./26.UttaraBhadrapada.jpg": 5541,
	"./27.Revati.jpg": 6435,
	"./padas/NakshatraPada1.jpg": 9644,
	"./padas/NakshatraPada2.jpg": 9405,
	"./padas/NakshatraPada3.jpg": 269,
	"./padas/NakshatraPada4.jpg": 3724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 604;